import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const getModelosTipo = async () => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${API_URL}/api/modelosTipo`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const updateModeloTipo = async (id, data) => {
  const token = localStorage.getItem("token");
  return axios.put(`${API_URL}/api/modelosTipo/${id}`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const deleteModeloTipo = async (id) => {
  const token = localStorage.getItem("token");
  return axios.delete(`${API_URL}/api/modelosTipo/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
